<div class="recent-orders">
  <div class="title-buttons">
    <strong>New Page</strong>
  </div>

  <div class="table-responsive">
    <div class="form-page-block">
      <div class="card">
        <div class="card-header">
          <span>&nbsp;</span>
        </div>
        <div class="card-body">
          <form class="form-page" [formGroup]="form" (ngSubmit)="save()">

            <div class="row mb-4">
              <div class="col-md-6">
                <div class="input-field">
                  <label>Title (EN)</label>
                  <input type="text" class="form-control" formControlName="title" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-field">
                  <label>Title (FR)</label>
                  <input type="text" class="form-control" formControlName="titleFr" />
                </div>
              </div>
            </div>

            <div class="input-field mt-3">
              <label>Body (EN)</label>
              <div class="editor-wrapper">
                <quill-editor formControlName="content"></quill-editor>
              </div>
            </div>

            <div class="input-field mt-3">
              <label>Body (FR)</label>
              <div class="editor-wrapper">
                <quill-editor formControlName="contentFr"></quill-editor>
              </div>
            </div>

            <div class="form-actions">
              <button
                [disabled]="form.invalid || submitting"
                class="btn btn-success"
                id="btn-submit"
                type="submit">
                Save
              </button>
              <span *ngIf="submitting" class="saving-text">Saving...</span>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>